// Deep-link coupon auto-apply support (MVK-2468).
//
// FB ads / campaign links carry `?coupon=AEONBETA` so checkout can verify & apply
// the code without the user typing it. react-router drops the query string when
// the funnel navigates between steps (seats → concessions → checkout all use
// `navigate('../…')`), so the param is captured ONCE at SPA bootstrap
// (`entry.mount`, before React renders) into sessionStorage, then consumed when
// the checkout mounts. sessionStorage (not localStorage) scopes it to the tab so
// the code never leaks into an unrelated future booking.

const STORAGE_KEY = 'moveek_v2_autocoupon';

// Read `?coupon=` off the landing URL and stash it for the checkout step. Called
// once from `entry.mount()` before render, so it never races the consumer. No-op
// when the param is absent/blank or sessionStorage is unavailable (private mode).
export function captureAutoCouponFromUrl(search: string): void {
  try {
    const code = new URLSearchParams(search).get('coupon')?.trim();
    if (code) window.sessionStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* sessionStorage blocked — feature degrades to manual entry */
  }
}

// Consume the stashed code: returns it once, then clears it so the auto-apply
// fires exactly once across mounts/sessions (AC: chỉ auto-apply một lần). Returns
// null when nothing was stashed or storage is unavailable.
export function takeAutoCoupon(): string | null {
  try {
    const code = window.sessionStorage.getItem(STORAGE_KEY)?.trim();
    if (code) window.sessionStorage.removeItem(STORAGE_KEY);
    return code || null;
  } catch {
    return null;
  }
}
